import { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: 'Đại Học Hải Phòng',
  pwa: true,
  logo: 'https://dhhp.edu.vn/logo/logo-65.png',
  iconfontUrl: '',
  token: {
    sider: {
      colorMenuBackground: '#00387a',
      colorBgMenuItemHover: '#D02929',
      colorTextMenu: '#FFFFFF',
      colorTextMenuSelected: '#FFFFFF',
      colorTextMenuItemHover: '#FFFFFF',
      colorTextMenuActive: '#FFFFFF',
      colorBgMenuItemSelected: '#D02929',
      colorTextMenuSecondary: '#FFFFFF',
      colorTextMenuTitle: '#FFFFFF',
    }
  },
};

export default Settings;
